import { render, staticRenderFns } from "./search-box.vue?vue&type=template&id=3be428ac&scoped=true"
import script from "./search-box.vue?vue&type=script&lang=js"
export * from "./search-box.vue?vue&type=script&lang=js"
import style0 from "./search-box.vue?vue&type=style&index=0&id=3be428ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be428ac",
  null
  
)

export default component.exports